export const USER = 'user';